module.exports = __webpack_public_path__ + "media/images/icons/benefits_discount_on_instruments-c1068efebb94f8cb1d9ce8fc859df216.svg";